import AllSections from '../Components/AllSections';
import CreateSection from '../Components/CreateSection';

export const SectionRoutes = [
  {
    Component: AllSections,
    path: "/all",
    exact: true,
    id: "dashboardSectionsAll",
    routePath: "/dashboard/sections/all",
    name: "All Sections"
  },
  {
    Component: CreateSection,
    path: '/edit/:id',
    exact: true,
    id: 'dashboardSectionsEdit',
  },
  {
    Component: CreateSection,
    path: "/create",
    exact: true,
    id: "dashboardSectionsCreate",
    routePath: "/dashboard/sections/create",
    name: "Create Section"
  }
];
